export const variantClasses = {
  smLink: "text-sm text-link", // leave for now

  xlH1Medium: "text-xl text-h1 font-medium", //marketing
  xlCtaSemibold: "text-xl text-cta font-semibold", //marketing
  twoXlH2: "text-2xl text-h2 font-normal", //marketing

  body: "text-base font-normal leading-5 text-primary", //this is the default in the systemDesign it's mdBody
  smBody: "text-sm font-normal leading-[18px] text-primary",
  smBodyError: "text-sm font-normal leading-[18px] text-error",
  smBodyWarning: "text-sm font-normal leading-[18px] text-warning",
  bodyWarning: "text-base font-normal leading-[18px] text-warning",
  lgBody: "font-normal text-lg leading-[22px] text-primary",
  label: "text-base font-semibold leading-5 text-primary", //this is the default in the systemDesign it's mdLabel
  smLabel: "text-sm font-semibold leading-[18px] text-primary",
  lgLabel: "text-lg font-semibold  leading-[22px] text-primary",
  title1H1: "text-4xl text-h1 font-semibold tracking-tighter capitalize",
  title1H2: "text-4xl text-h2 font-semibold tracking-tighter capitalize",
  title1H3: "text-4xl text-h3 font-semibold tracking-tighter capitalize",
  title2H1: "text-3xl text-h1 font-semibold tracking-tight capitalize",
  title2H2: "text-3xl text-h2 font-semibold tracking-tight capitalize",
  title2H3: "text-3xl text-h3 font-semibold tracking-tight capitalize",
  title3H1: "text-2xl text-h1 font-semibold tracking-tight capitalize",
  title3H2: "text-2xl text-h2 font-semibold tracking-tight capitalize",
  title3H3: "text-2xl text-h3 font-semibold tracking-tight capitalize",
  smSubtitle: "text-[18px] font-semibold text-primary",
  lgSubtitle: "text-xl font-semibold capitalize text-primary",
  lgSubtitleH1: "text-xl font-semibold capitalize text-h1",
  lgSubtitleH2: "text-xl font-semibold capitalize text-h2",
  lgSubtitleH3: "text-xl font-semibold capitalize text-h3",
  bodySecondary: "text-base font-normal leading-5 text-secondary",
  smBodySecondary: "text-sm font-normal leading-[18px] text-secondary",
  lgBodySecondary: "font-normal text-lg leading-[22px] text-secondary",
  labelSecondary: "text-base font-semibold leading-5 text-secondary",
  smLabelSecondary: "text-sm font-semibold leading-[18px] text-secondary",
  lgLabelSecondary: "text-lg font-semibold leading-[22px] text-secondary",
  smSubtitleSecondary: "text-lg font-semibold text-secondary",
  lgSubtitleSecondary: "text-xl font-semibold capitalize text-secondary",
  bodyTertiary: "text-base font-normal leading-5 text-tertiary",
  smBodyTertiary: "text-sm font-normal leading-[18px] text-tertiary",
  lgBodyTertiary: "font-normal text-lg leading-[22px] text-tertiary",
  labelTertiary: "text-base font-semibold leading-5 text-tertiary",
  smLabelTertiary: "text-sm font-semibold leading-[18px] text-tertiary",
  lgLabelTertiary: "text-lg font-semibold leading-[22px] text-tertiary",
  smSubtitleTertiary: "text-lg font-semibold text-tertiary",
  lgSubtitleTertiary: "text-xl font-semibold capitalize text-tertiary"
};
